import api from '@/services/api/config';

const path = 'v1/eingangsrechnung/import';

export default {
  getStatistik: () => api.get(`${path}/statistik`),
};
